import Routers from "routes/Routers";
// import "./app.scss";

function App() {
  return <Routers />;
}

export default App;
